import {
  Component,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ClientEvent } from '../../../../../app/shared/services/events.service';

@Component({
  selector: 'app-event-card',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    @if (event) {
    <div
      class="card"
      (click)="handleLinkClick(event)"
      (keydown.enter)="handleLinkClick(event)"
    >
      <div class="group-image field-group">
        <div class="field">
          <img
            loading="lazy"
            [src]="event.photoUrl"
            width="416"
            height="416"
            alt=""
          />
        </div>
        <time
          [title]="event.start | date : 'longDate'"
          [attr.datetime]="startTimeISO()"
          class="emblem"
        >
          <span class="day">{{ event.start | date : 'dd' }}</span>
          <span class="month">{{ event.start | date : 'MMM' }}</span>
        </time>
      </div>
      <div class="field title">
        <a [href]="event.link" target="_blank">
          <h3 class="m-0">
            <span class="deco">{{ event.title }}</span>
          </h3>
        </a>
      </div>
      <div class="group-fields field-group">
        <div class="field meta">
          <p>
            <mat-icon>access_time</mat-icon>
            <span class="sr-only">Time: </span>
            @if (isAllDayEvent()) {
            <span class="pl">All Day</span>
            } @else {
            <span class="pl">
              {{ event.start | date : 'shortTime' }} to
              {{ event.end | date : 'shortTime' }}
            </span>
            }
          </p>
          <!-- prettier-ignore -->
          @if ( event.location && !event.location.includes('Sign in to download the location')){
          <p>
            <mat-icon>place</mat-icon>
            <span class="sr-only">Location: </span>
            <span class="pl">{{ event.location }}</span>
          </p>
          }
        </div>
      </div>
    </div>
    }
  `,
  styleUrls: ['./event-card.component.scss'],
})
export class EventCardComponent implements OnInit {
  @Input() event?: ClientEvent;
  // Initialize the start time ISO string signal
  startTimeISO = signal(this.getStartTimeISOString());
  constructor(@Inject(PLATFORM_ID) private platformId: string) {}

  get isBrowserOnly(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.updateStartTimeISO();
  }

  // Method to safely convert start time to ISO string
  getStartTimeISOString(): string | undefined {
    if (!this.event) {
      return '';
    }
    const startTime = this.event.start;
    if (typeof startTime === 'string') {
      return new Date(startTime).toISOString();
    }
    return startTime?.toISOString();
  }

  isAllDayEvent() {
    if (!this.event) {
      return false;
    }
    return this.event.start === this.event.end;
  }

  // Method to update the startTimeISO signal
  updateStartTimeISO() {
    this.startTimeISO.set(this.getStartTimeISOString());
  }

  handleLinkClick(event: ClientEvent) {
    if (this.isBrowserOnly) {
      window.open(event.link, '_blank');
    }
  }
}
